import React from 'react';
import { Box, Heading, NavigationToggler } from '@common-fe/common-fe';

import Permissions from '@/common/permissions';

import { useHasAccess } from '../core/hooks';

import FieldLevelAccessSetupAddModal from './FieldLevelAccessSetup/FieldLevelAccessSetupAddModal';
import { RolesAndSecurityTabs } from './role.types';
import { RoleSetupAddModal } from './RoleSetup';

interface Props {
  currentTab: RolesAndSecurityTabs;
  tabs: RolesAndSecurityTabs[];
  onSetCurrentTab: (value: RolesAndSecurityTabs) => void;
}
export const RolesAndSecurityHeader: React.FC<Props> = ({ currentTab, tabs, onSetCurrentTab }) => {
  const isCreateAvailable = useHasAccess([{ permission: Permissions.EDIT_ROLES_AND_SECURITY }]);
  const isTabsAvailable = useHasAccess([{ permission: Permissions.VIEW_ROLES_AND_SECURITY }]);

  return (
    <Box margin={{ bottom: 'spacing24' }} data-testid="RolesAndSecurityHeader">
      <Box direction="row" justify="between" align="center">
        <Box>
          <Heading data-testid="RolesAndSecurity_header_title" level={1} size="regular" color="textTitle">
            {currentTab === RolesAndSecurityTabs.ROLES && RolesAndSecurityTabs.ROLES}
            {currentTab === RolesAndSecurityTabs.FIELD_LEVEL_ACCESS &&
              RolesAndSecurityTabs.FIELD_LEVEL_ACCESS}
          </Heading>
        </Box>
        <Box flex direction="row" justify="end" align="center" height="40px">
          <Box direction="row" gap="spacing24" align="center">
            {isTabsAvailable && (
              <NavigationToggler
                value={currentTab}
                options={tabs}
                onChange={(value: string) => onSetCurrentTab(value as RolesAndSecurityTabs)}
                testId="RolesAndSecurityHeaderNavigationToggler"
              />
            )}
            {isCreateAvailable && currentTab === RolesAndSecurityTabs.ROLES && <RoleSetupAddModal />}
            {isCreateAvailable && currentTab === RolesAndSecurityTabs.FIELD_LEVEL_ACCESS && (
              <FieldLevelAccessSetupAddModal />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
